module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chaptitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }), _c('b', [_vm._v("TABLES")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/ch01#rtab1",
      "id": "tab1"
    }
  }, [_vm._v("Table I.    Confederate Cavalry Units Raised in the Trans-Mississippi during 1861")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch02#rtab2",
      "id": "tab2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table II.   Confederate Cavalry Units Crossing the Mississippi in the Spring of 1862")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch02#rtab3",
      "id": "tab3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table III.  Confederate Cavalry Units Raised in Texas by Mid-September, 1862")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch04#rtab4",
      "id": "tab4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table IV. The Supply of Horses in the Trans-Mississippi")])])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/ch04#rtab5",
      "id": "tab5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table V.  Horses in Marmaduke’s Cavalry Division")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b54d8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables.vue
// module id = 84
// module chunks = 0